import { Skeleton } from "../Skeleton.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/skeleton/variants/RoundedSkeleton.tsx
const RoundedSkeleton = ({ height, width, visible, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(Skeleton, {
		width,
		height,
		visible,
		"data-testid": testId
	});
};

//#endregion
export { RoundedSkeleton };